module.exports = __webpack_public_path__ + "static/img/5.88084fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-es/5.jpg
// module id = iatu
// module chunks = 1